module.exports = __webpack_public_path__ + "static/media/icn-search.c7a6e8d6.svg";